export const contractTypes = {
	Lease: 'Lease',
	PPA: 'PPA',
};
